import { Alert, Box, CircularProgress, Stack, Typography } from "@mui/material";
import type { PimoReactComponent } from "@pimo/pimo-app-builder";
import { getLocalizedMessage, type SupportedLanguage } from "@pimo/pimo-l10n";

export type MagicLinkPageProps = {
  hasError?: boolean;
  language: SupportedLanguage;
};

export const MagicLinkPage: PimoReactComponent<MagicLinkPageProps> = ({
  hasError = false,
  language,
}) => {
  const signingInMessage =
    getLocalizedMessage(language, "magicLink.signingIn") || "Signing in";
  const redeemFailedMessage =
    getLocalizedMessage(language, "magicLink.redeemFailed") ||
    "This magic link is invalid or expired. Request a new link and try again.";

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        px: 2,
      }}
    >
      {hasError ? (
        <Alert severity="error">{redeemFailedMessage}</Alert>
      ) : (
        <Stack alignItems="center" spacing={2}>
          <CircularProgress aria-label={signingInMessage} />
          <Typography component="p" variant="h6">
            {signingInMessage}
          </Typography>
        </Stack>
      )}
    </Box>
  );
};
